export const PROSPECT_REFERRAL_BASE_PATH = '/lead-form/prospect-referral';
export const PROSPECT_REFERRAL_NAMESPACE = 'PROSPECT_REFERRAL';

export const MANDATORY_FIELD_ERROR_TEXT = 'This field is mandatory';

export const PROSPECT_REFERRAL_TITLE = 'title.prospect-referral';

export const PROSPECT_REFERRAL_DEFAULT_CAMPAIGN_ID = 'Ketnoi_KHTN';

export const PROSPECT_REFERRAL_INITIAL_ITEM_LEAD_SOURCES: Array<{ _id: string; sourceId: string; sourceName: string }> = [
  { _id: 'Ketnoi_KHTN', sourceId: 'Ketnoi_KHTN', sourceName: 'Kết Nối KHTN' },
];

export const PROSPECT_REFERRAL_WEBFLOW_URL_UAT = 'https://gioi-thieu-khach-hang-tiem-nang-UAT.webflow.io';
export const PROSPECT_REFERRAL_WEBFLOW_URL_PROD = 'https://gioi-thieu-khach-hang-tiem-nang.webflow.io';

export enum AdminProspectReferralPermissionType {
  PROSPECT_REFERRAL_READ = 'READ_ANY_PROSPECT_REFERRAL',
  PROSPECT_REFERRAL_CREATE = 'CREATE_ANY_PROSPECT_REFERRAL',
  PROSPECT_REFERRAL_UPDATE = 'UPDATE_ANY_PROSPECT_REFERRAL',
}
